import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-xero',
  templateUrl: './link-xero.component.html',
  styleUrls: ['./link-xero.component.scss'],
})
export class LinkXeroComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Output() next = new EventEmitter();
  public busy = false;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('XERO_CHANNEL');
  public win;
  //VERY COOL LINK
  //https://stackoverflow.com/questions/28230845/communication-between-tabs-or-windows
  //XERO - JC

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.broadcastChannel.onmessage = (ev) => {
      if (ev.data === 'CONNECTED') {
        this.busy = false;
        this.connected = true;
        this.message = this.translate.instant(
          'onboarding.messages.xero_connected',
        );
        setTimeout(() => {
          this.posIntegrationService
            .startFullPOSSync(this.partner.PartnerID)
            .subscribe(
              (sync) => {},
              (err) => {},
            );
        }, 10000);
      } else {
        this.busy = false;
        this.message = this.translate.instant(
          'onboarding.messages.xero_not_connected',
        );
      }
    };

    //Check if the POS is already connected to the selected POS System
    this.busy = true;
    this.posIntegrationService
      .checkPOSIntegration(this.partner.PartnerID, this.selectedPOS.POSID)
      .subscribe(
        (result) => {
          this.message = this.translate.instant(
            'onboarding.messages.xero_connected',
          );
          this.connected = true;
          this.busy = false;
        },
        (err) => {
          this.busy = false;
          this.connected = false;
        },
      );
  }

  ngOnDestroy() {}

  connectXero() {
    localStorage.setItem('XeroPartnerID', this.partner.PartnerID); //Not Ideal but cant find another easy way to pass this to the other window, and the backend makes it more challenging
    var data = {
      ID: this.partner.PartnerID,
    };
    this.busy = true;
    this.connected = false;
    this.message = null;
    this.posIntegrationService.getXeroAuthURL(data).subscribe(
      (auth: any) => {
        var authURL = auth.AuthURL;
        if (authURL && authURL.length > 0) {
          this.win = this.posIntegrationService.launchXeroAuthPopup(authURL);
          this.checkWindow();
        } else {
          this.busy = false;
          this.message = '';
        }
      },
      (err) => {
        this.message = this.translate.instant(
          'onboarding.messages.error_fetching_auth_url',
        );
        this.busy = false;
      },
    );
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win.parent === null) {
        this.busy = false;
      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }
}
